export default __webpack_public_path__ + "static/8343-9eb8f29e5445df103813ad4fc1c5057b.jpg";